import React from 'react';

const AdditionSymbol = () => {
	return (
		<>
			<div className="addition-symbol">+</div>
		</>
	);
};

export default AdditionSymbol;
